import React from "react";
import { useFeatureFlag, useInitialize, useVisitorCode } from "@kameleoon/react-sdk";

import { getExternalKameleoonVisitorCode } from "../../../kameleoon/visitorCode";
import CarLoader from "../CarLoader";
import Loader from "../Loader";

export const CAR_LOADER_FEATURE_KEY = "car_loader";

const LoaderStep = () => {
  const { isInitialized } = useInitialize();
  const { isFeatureFlagActive } = useFeatureFlag();
  const { getVisitorCode } = useVisitorCode();

  let showCarLoader = false;
  if (isInitialized()) {
    try {
      // Prefer the merchant page's visitor code (persists first-party) over
      // the SDK's own, which can't survive between sessions in this iframe.
      const visitorCode = getExternalKameleoonVisitorCode() || getVisitorCode();
      showCarLoader = isFeatureFlagActive(visitorCode, CAR_LOADER_FEATURE_KEY);
    } catch (error) {
      console.error("[Kameleoon] car_loader flag check failed:", error.message);
    }
  }

  return showCarLoader ? <CarLoader /> : <Loader />;
};

export default LoaderStep;
